import { NgModule } from '@angular/core';
import { SharedModule } from "app/shared/shared.module";
import { RouterModule } from "@angular/router";
import { ADMIN_ROUTES } from "app/admin/admin.routing";
import { AdminService } from 'app/admin/services/admin.service';
import { AdminComponent } from 'app/admin/component/admin/admin.component';
import { CoreModule } from 'app/core/core.module';

@NgModule({
    imports: [
        CoreModule,
        SharedModule,
        RouterModule.forChild(ADMIN_ROUTES)
    ],
    declarations: [AdminComponent],
    providers: [AdminService]
})
export class AdminModule { }
